export default __webpack_public_path__ + "static/blades-933c6f07793c5e4e9e3fb57cb0bc1eb7.png";